<template>
  <div>
    <profile-stats :user-details="userDetails"/>
    <div v-if="getThemes.length === 0">
      <empty-state :on-click-action="playMethod"/>
    </div>
    <div v-else>
      <performance :title="getTranslations.home_profile_default_content_your_performance"
                   :sub-title="getTranslations.home_profile_default_content_theme_performance"
                   :user-info="userDetails"
                   :fit="false"
                   :themes="getThemes || []">
       <template>
         <div class="profile__block__header subheader achievements_content">
           <h2>{{ getTranslations.home_profile_achievements_in_progress }}</h2>
           <p>{{ getTranslations.home_profile_achievements_in_progress_description }}</p>
         </div>
         <div class="profile__block__content profile__block__content--theme-performance">
           <div class="achiev-cont">
             <div class="achiev-cont__icon"
                  v-for="(achievement, index) in achievementsInProgress"
                  v-if="index < page*8"
                  :key="index">
               <img :src="getAchievementImagePath(achievement.category, achievement.index)" alt="">
               <div class="new_badge"
                  v-if="achievement.percentage === 0">
                 <img src="/static/images/new_icon.svg" alt="">
               </div>
               <p>{{ achievement.achievementLevelName }}</p>
               <span>{{ achievement.percentage }}%</span>
             </div>
           </div>
           <div class="achievements_btn">
             <a href="#"
                v-if="page*8 < achievementsInProgress.length"
                @click.prevent="loadMore()"
                class="btn2 btn--v2 btn2--small btn2--green">
               {{ getTranslations.home_profile_achievements_in_progress_see_all }}
             </a>
           </div>
         </div>
       </template>
      </performance>
    </div>
  </div>
</template>


<script>
  /* eslint no-param-reassign: ["error", { "props": false }], no-console: "off" */
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import ResumeGame from '@/components/home/modals/ResumeGame';
import ZeroBalance from '@/components/home/modals/ZeroBalance';
import ResubscribeGameSms from '@/components/home/modals/ResubscribeGameSms';
import ResubscribeGame from '@/components/home/modals/ResubscribeGame';
import Performance from '@/components/home/profile/Performance';
import ProfileStats from '@/components/home/profile/ProfileStats';
import EmptyState from '@/components/home/profile/EmptyState';
import SearchSpecificUser from '@/components/home/modals/users/SearchSpecificOpponent';

export default {
  name: 'profile-default-content',
  components: {
    ProfileStats,
    Performance,
    EmptyState,
  },
  data() {
    return {
      page: 1,
    };
  },
  methods: {
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    getAchievementImagePath(category, index) {
      return `/static/images/achievements_cat/${category.toLowerCase()}_${index + 1}.png`;
    },
    loadMore() {
      this.page = this.page + 1;
    },
    playFriend() {
      this.storeModalForHomePage(SearchSpecificUser);
    },
    playRandom() {
      console.log('showing resume game pop up in DefaultContentProfile Page...');
      this.checkIfGameToResumeExists().then(() => {
        console.log('this.gameInProgress:', this.gameInProgress);
        if (this.gameInProgress) {
          console.log('showing resume game pop up...');
          this.storeModalForHomePage(ResumeGame);
        } else if (this.userDetails.availableGames === 0 && !this.userDetails.subscribed) {
          if (this.subAndUnsubViaSMS) {
            if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
              this.storeModalForHomePage(ResubscribeGameSms);
            } else {
              this.storeModalForHomePage(ResubscribeGame);
            }
          } else {
            this.storeModalForHomePage(ResubscribeGame);
          }
        } else if (this.userDetails.availableGames === 0 && this.userDetails.subscribed) {
          this.storeModalForHomePage(ZeroBalance);
        } else {
          this.$router.push('/searchingOpponent');
          this.storeModalForHomePage(null);
        }
      }).catch(error => console.error(error));
    },
    playMethod(mode) {
      switch (mode) {
      case 0: this.playRandom();
        break;
      case 1: this.playFriend();
        break;
      default: break;
      }
    },
  },
  computed: {
    achievementsInProgress() {
      return this.achievements
        .flatMap(a => a.achievementDTOs)
        .flatMap(ad => ad.achievementLevelDTOs.map(ald => ({ ...ald, category: ad.achievementName })))
        .filter(al => al.current);
    },
    ...mapState('game', [
      'gameInProgress',
    ]),
    ...mapState('common', [
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
    ]),
    ...mapState('profile', [
      'achievements',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getThemes',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/DefaultContentProfile.vue